import Person from '@components/testimonials/Person';
import Statement from '@components/testimonials/Statement';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import IVCard from '@invideoio/web-shared/components/Card';
import { TestimonialCard } from 'src/types';

interface TestimonyProps {
  testimony: TestimonialCard;
}

const Testimony = ({ testimony }: TestimonyProps) => {
  return (
    <IVCard
      className={ivclass(
        'iv-bg-black-4',
        'iv-rounded-30',
        'iv-mr-40 md:iv-mr-25 sm:iv-mr-20',
        'xl:iv-p-40 iv-p-35 sm:iv-p-25',
        'xl:iv-w-[380px] iv-w-[320px] sm:iv-w-[235px]',
      )}
    >
      <Person image={testimony.authorPofile} name={testimony.author} />
      <Statement statement={testimony.testimonial} />
      <div
        className={ivclass(
          'iv-text-body-3xl iv-text-black-85 iv-font-medium',
          'sm:iv-text-body-xl',
        )}
      >
        {testimony.author}
      </div>
    </IVCard>
  );
};

export default Testimony;
